export default __webpack_public_path__ + "images/GT.6a2f903.png";